<template>
  <Modal :is-open="props.isOpenModal" @close="emits('on-close')">
    <section class="modal-pix-received">
      <InitialAvatarIcon
        class="modal-pix-received__icon"
        icon="EF0070"
        size="medium"
      />
      <Heading class="modal-pix-received__heading" :level="3"
        >Recebemos seu depósito
        <span v-if="transformCurrencyAmount"
          >de<br />{{ transformCurrencyAmount }}</span
        ></Heading
      >
      <div class="modal-pix-received__button-area">
        <BaseText
          class="modal-pix-received__text-bold"
          size="p4"
          :color="NebraskaColors.elementPrimary"
          >O que você quer fazer agora?</BaseText
        >
        <template v-if="shouldShowInvestmentFlowButtons">
          <ButtonBoxDecide
            icon="BA0020"
            label="Continuar com seu investimento"
            @click="() => router.push({ path: $route.params.cameFrom })"
          />
          <ButtonBoxDecide
            icon="CA0010"
            label="Voltar para o início"
            @click="() => router.push({ name: 'home' })"
          />
        </template>
        <template v-else>
          <ButtonBoxDecide
            icon="BA0050"
            label="Investir em Carteiras"
            @click="() => router.push({ name: 'wealth' })"
          />
          <ButtonBoxDecide
            :disabled="!isMarketAvailable"
            icon="BB0040"
            label="Investir em Bolsa"
            :badge-label="isMarketAvailable ? '' : 'Mercado fechado'"
            @click="() => router.push({ name: 'trade' })"
          />
        </template>
      </div>
    </section>
  </Modal>
</template>

<script setup lang="ts">
import {
  Modal,
  InitialAvatarIcon,
  Heading,
  BaseText,
  ButtonBoxDecide
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { tradeModule } from '@/modules/trade/store/trade';
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import type { IPixRequestMessage } from '@/modules/cash/views/Deposit/types.ts';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

interface Props {
  isOpenModal: boolean;
  messageData: IPixRequestMessage['message'] | null;
}

interface Emits {
  (event: 'on-close'): void;
}

const props = defineProps<Props>();

const emits = defineEmits<Emits>();

const router = useRouter();
const route = useRoute();

const isMarketAvailable = computed(
  () => tradeModule.tradeStatus?.marketAvailable?.isMarketAvailable
);

const transformCurrencyAmount = computed(() => {
  if (!props.messageData?.amount) return null;
  return moneyFormat(props.messageData.amount as number);
});

const shouldShowInvestmentFlowButtons = computed(() => {
  return route.params.cameFrom;
});
</script>

<style scoped lang="less">
.base-modal--container {
  :deep(.base-modal--wrapper) {
    width: 592px;
    max-width: 592px;
    max-height: 92vh;
  }

  :deep(.modal-content) {
    padding-top: 0;
  }
}

.modal-pix-received {
  text-align: left;
  width: 100%;
  padding: 0 @size-spacing-x600 @size-spacing-x600;

  &__icon {
    background-color: @status-positive-background;
    color: @status-positive;
  }

  &__heading {
    font-weight: 400;
    margin-top: @size-spacing-x400;
  }

  &__text-bold {
    font-weight: 600;
  }

  &__button-area {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x300;
    width: 100%;
    margin-top: @size-spacing-x1000;
  }
}
</style>
